import UniversalConsentItemCreateEdit from './UniversalConsentItemCreateEdit';

export default UniversalConsentItemCreateEdit;
